import {mapGetters} from 'vuex';
import {getImageUrl, onError} from '@/libs/helper'

export default{
    props:{
        alphabet: {
            type: String,
            default: () => ''
        },
        list: {
            type: Array,
            default: () => []
        },
        module: {
            type: String,
            required: true,
            default: () => ''
        }
    },
    computed: {
        ...mapGetters({
            userInformation: 'getUserInformation'
        })
    },
    data(){
        return{
            getImageUrl: getImageUrl,
            onError: onError
        }
    },
    methods:{
        routeToDetailPage(record){
            this.$router.push(`${this.module.toLowerCase()}s/${record._id}/`)
        }
    }
}